import React from 'react';

const hedFromProps = (props) => {
    if(props.hed) {
        return <h3 className="hed inset-text">{props.hed}</h3>
    }
    return null;
}
const dekFromProps = (props) => {
    if(props.dek) {
        return <div className="dek inset-text">{props.dek}</div>
    }
    return null;
}



const notesFromProps = (props) => {
    if(props.notes) {
        
        return <div className="notes">
            {props.notes.map((note) => {
                if(note.slice(0,1)==="*") {
                    return <div className="note"><super>*</super>{note.slice(1)}</div>    
                }
                return <div className="note">{note}</div>
            })}
        </div>;
    }
    return null;
}
const sourceFromProps = (props) => {
    if(props.source) {
        return <div className="source">{props.source}</div>
    }
    return null;       
} 


export default (props) => {
    
    return <div className="inset inset-text">
        <div className="forward">
            {hedFromProps(props)}
            {dekFromProps(props)}
        </div>
        {props.children}
        <div className="addendum">
            {notesFromProps(props)}
            {sourceFromProps(props)}
        </div>
    </div>
  
}


// WEBPACK FOOTER //
// ./src/js/components/Inset/Inset.jsx